import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { VwActividadPlanTrabajo } from '../../plan-trabajo/models/actividad.model';
import { VwMisTemasCapacitacion } from '../../plan-capacitacion/models/tema-principal.model';
import { GetAllAccidenteTrabajoModel } from '../../accidente-trabajo/models/accidente-trabajo.model';
import {
  DashboardKpiGlobal,
  DashboardSociodemografico,
  DashboardAccidentes,
  DashboardPlanTrabajo,
  DashboardPlanCapacitacion,
  DashboardEnfermedadLaboral,
  DashboardCasosMedicos
} from '../dashboard/dashboard-data.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getAllActividadesByPlanTrabajo(empleadoId: any, startDate: string, endDate: string) {
    return this.http.get<VwActividadPlanTrabajo[]>(`${GlobalComponent.API_URL}dashboard/actividades?id=${empleadoId}&startDate=${startDate}&endDate=${endDate}`, { reportProgress: true, observe: "events" });
  }

  getMisTemasPrincipales(empleadoId: any, startDate: string, endDate: string) {
    return this.http.get<VwMisTemasCapacitacion[]>(`${GlobalComponent.API_URL}dashboard/temas?id=${empleadoId}&startDate=${startDate}&endDate=${endDate}`, { reportProgress: true, observe: "events" });
  }

  getAllAccidentesTrabajo(empleadoId: any, startDate: string, endDate: string) {
    return this.http.get<GetAllAccidenteTrabajoModel[]>(`${GlobalComponent.API_URL}dashboard/accidentes?id=${empleadoId}&startDate=${startDate}&endDate=${endDate}`, { reportProgress: true, observe: "events" });
  }

  getKpiGlobal(): Observable<DashboardKpiGlobal> {
    return this.http.get<DashboardKpiGlobal>(`${GlobalComponent.API_URL}dashboard/kpi-global`);
  }

  getSociodemografico(): Observable<DashboardSociodemografico> {
    return this.http.get<DashboardSociodemografico>(`${GlobalComponent.API_URL}dashboard/perfil-sociodemografico`);
  }

  getAccidentesResumen(): Observable<DashboardAccidentes> {
    return this.http.get<DashboardAccidentes>(`${GlobalComponent.API_URL}dashboard/accidentes-resumen`);
  }

  getPlanTrabajoResumen(): Observable<DashboardPlanTrabajo> {
    return this.http.get<DashboardPlanTrabajo>(`${GlobalComponent.API_URL}dashboard/plan-trabajo-resumen`);
  }

  getPlanCapacitacionResumen(): Observable<DashboardPlanCapacitacion> {
    return this.http.get<DashboardPlanCapacitacion>(`${GlobalComponent.API_URL}dashboard/plan-capacitacion-resumen`);
  }

  getEnfermedadLaboralResumen(): Observable<DashboardEnfermedadLaboral> {
    return this.http.get<DashboardEnfermedadLaboral>(`${GlobalComponent.API_URL}dashboard/enfermedad-laboral-resumen`);
  }

  getCasosMedicosResumen(): Observable<DashboardCasosMedicos> {
    return this.http.get<DashboardCasosMedicos>(`${GlobalComponent.API_URL}dashboard/casos-medicos-resumen`);
  }
}
